<template>
  <div class="table">
    <div class="row">
      <div
        class="item"
        style="border-right: solid #EBEEF5 1px;"
      >
        调剂来源
      </div>
      <div
        class="item"
        style="border-right: solid #EBEEF5 1px;"
      >
        院校名称
      </div>
      <div class="item">
        人数
      </div>
    </div>
    <div class="columns">
      <div class="block1">
        <span>调剂到本院校
          专业的考生
          来源院校</span>
      </div>
      <div class="block2">
        <div
          class="wrap"
          v-for="(item,index) in list"
          :key="index"
        >
          <div
            class="item"
            style="border-right: solid #EBEEF5 1px;border-left: solid #EBEEF5 1px;"
          >
            <span>{{item.name}}</span>
          </div>
          <div class="item">
            <span style="color: #1D6FE9;">{{item.count.charAt(0)}}</span>人
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
        
 <script>


export default {
  components: {
  },
  props: {
    data: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      list: [],
    }
  },
  watch: {

  },
  created() {
    let arr = this.data.split(',')
    this.list = arr.map(v => {
      if (v.split('）').length > 1) {
        return {
          count: v.split('）')[1],
          name: v.split('）')[0],
        }
      } else if (v.split('大学').length > 1) {
        return {
          count: v.split('大学')[1],
          name: v.split('大学')[0] + '大学',
        }
      } else if (v.split('学院').length > 1) {
        return {
          count: v.split('学院')[1],
          name: v.split('学院')[0] + '学院',
        }
      }
    })
  },
  methods: {


  }
}
   </script>
  <style lang="less" scoped>
.table {
  width: 100%;

  border: solid #eaeaea 1px;
  .row {
    display: flex;
    align-items: center;
    .item {
      flex: 1;
      padding: 12px 0px;
      background-color: #ecf2fe;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
    }
  }
  .columns {
    display: flex;

    .block1 {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        text-align: center;
        /*  width: 144rpx; */
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        line-height: 17px;
      }
    }

    .block2 {
      flex: 2;

      .wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        .item {
          width: 100%;
          box-sizing: border-box;
          border-top: solid #eaeaea 1px;
          padding: 10px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.9);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          span {
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
        